<template>
	<div>
		<a-page-header style="background: #fff;" title="主播详情" />
		<a-row>
			<a-col :span="8">
				<div class="mainBox">
					<div class="contentBox" v-if="basicForm">
						<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" action="http://gn.jh0454.com/index.php/adminapi/qiniu/uploadtwo"
						 @change="photoChange">
							<img v-if="basicForm.photo" :src="basicForm.photo" alt="avatar" style=" width: 150px;height: 200px;" />
							<div v-else>
								<a-icon :type="loading ? 'loading' : 'plus'" />
								<div class="ant-upload-text">形象照片</div>
							</div>
						</a-upload>
						<a-page-header :ghost="false" :title="basicForm.name" :subTitle="'ID ' + basicForm.id" style="margin-top:20px">
							<a-descriptions size="small" :column="1">
								<a-descriptions-item label="是否有效">
									<a-tag :color="basicForm.isValid == 1 ? 'orange':''">{{basicForm.isValid == 1 ? '有效主播':'无效主播'}}</a-tag>
								</a-descriptions-item>
								<a-descriptions-item label="姓名"><strong>{{basicForm.name}}</strong></a-descriptions-item>
								<a-descriptions-item label="电话"><strong>{{basicForm.phone}}</strong></a-descriptions-item>
								<a-descriptions-item label="性别"><strong v-if="basicForm.sex == '1'">男</strong><strong v-if="basicForm.sex == '2'">女</strong></a-descriptions-item>
								<a-descriptions-item label="身份证号"><strong>{{basicForm.idcard}}</strong></a-descriptions-item>
								<a-descriptions-item label="身高" v-if="basicForm.stature"><strong>{{basicForm.stature}} cm</strong></a-descriptions-item>
								<a-descriptions-item label="体重" v-if="basicForm.weight"><strong>{{basicForm.weight}} kg</strong></a-descriptions-item>
								<a-descriptions-item label="特长"><strong>{{basicForm.speciality}}</strong></a-descriptions-item>
								<a-descriptions-item label="自我介绍"><strong>{{basicForm.cont}}</strong></a-descriptions-item>
								<a-descriptions-item label="添加时间">{{basicForm.addtime}}</a-descriptions-item>
							</a-descriptions>
						</a-page-header>
					</div>
				</div>
			</a-col>

			<a-col :span="16" style="padding: 20px 20px 20px 0;">
				<div style="background: #fff;padding:20px">
					<a-tabs default-active-key="1" @change="tabChange">
						<!-- 基本信息 -->
						<a-tab-pane key="1">
							<span slot="tab">
								<a-icon type="contacts" />
								基本信息
							</span>
							<a-form-model ref="basicForm" :model="basicForm" :rules="basicFormRules">
								<a-row :gutter="[16,8]">
									<a-col :span="8">
										<a-form-model-item label="姓名" prop="name">
											<a-input style="width: 90%" v-model="basicForm.name" />
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="电话" prop="phone">
											<a-input style="width: 90%" v-model="basicForm.phone" />
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="性别" prop="sex">
											<a-radio-group v-model="basicForm.sex">
												<a-radio value="1">男</a-radio>
												<a-radio value="2">女</a-radio>
											</a-radio-group>
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="身份证号" prop="idcard">
											<a-input style="width: 90%" v-model="basicForm.idcard" />
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="身高" prop="stature">
											<a-input style="width: 90%" v-model="basicForm.stature" suffix="cm" />
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="体重" prop="weight">
											<a-input style="width: 90%" v-model="basicForm.weight" suffix="kg" />
										</a-form-model-item>
									</a-col>
									<a-col :span="24">
										<a-form-model-item label="特长">
											<a-textarea v-model="basicForm.speciality" :rows="4" />
										</a-form-model-item>
									</a-col>
									<a-col :span="24">
										<a-form-model-item label="自我介绍">
											<a-textarea v-model="basicForm.cont" :rows="4" />
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="关联微信wx">
											<a-select show-search option-label-prop="label" optionFilterProp="label" v-model="basicForm.wx">
												<a-select-option :value="item.value" :label="item.label" v-for="(item,index) in wxList" :key="index">
													<a-avatar :src="item.headpic" />
													{{item.label}}
													<a-icon type="man" style="color:#597ef7 ;" v-if="item.sex == 1" />
													<a-icon style="color:#f759ab ;" type="woman" v-if="item.sex == 2" />
												</a-select-option>
											</a-select>
										</a-form-model-item>
									</a-col>
									<a-col :span="8">
										<a-form-model-item label="是否为有效主播isValid 1有 0无">
											<a-radio-group v-model="basicForm.isValid">
												<a-radio :value="1">有效</a-radio>
												<a-radio :value="0">无效</a-radio>
											</a-radio-group>
										</a-form-model-item>
									</a-col>
									<a-col :span="24">
										<a-form-model-item style="text-align: right;">
											<a-button type="primary" @click="basicSubmit">
												保存
											</a-button>
										</a-form-model-item>
									</a-col>
								</a-row>
							</a-form-model>
						</a-tab-pane>

						<!-- 工资日历 -->
						<a-tab-pane key="2">
							<span slot="tab">
								<a-icon type="pay-circle" />
								工资
							</span>
							<a-calendar>
								<ul slot="dateCellRender" slot-scope="value" class="events">
									<li v-for="(item,index) in getListData(value).listData" :key="index" @click="editWage(getListData(value).id)">
										<span v-if="item.type == '流水'" style="">流水:{{item.content}}</span>
										<span v-if="item.type == '系数'" style="">系数:{{item.content}}</span>
										<span v-if="item.type == '实发工资'" style="color: #73d13d;">实发工资:{{item.content}}</span>
									</li>
								</ul>
							</a-calendar>
							<div style="text-align: right;">
								<a-button type='primary' @click="addWageModal = true">添加流水</a-button>
							</div>
						</a-tab-pane>

						<!-- 邀请 -->
						<a-tab-pane key="3">
							<span slot="tab">
								<a-icon type="cluster" />
								邀请
							</span>
						</a-tab-pane>

						<!-- 分享记录 -->
						<a-tab-pane key="4">
							<span slot="tab">
								<a-icon type="share-alt" />
								分享记录
							</span>
						</a-tab-pane>
					</a-tabs>
				</div>
			</a-col>
		</a-row>

		<!-- 添加工资弹窗 -->
		<a-modal v-model="addWageModal" title="添加流水" @ok="addWageSubmit" ok-text="添加" cancel-text="取消">
			<a-form-model ref="addWageForm" :model="addWageForm" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="工资日期" prop="date">
					<a-date-picker v-model="addWageForm.date" />
				</a-form-model-item>
				<a-form-model-item label="流水" prop="ls">
					<a-input prefix="￥" v-model="addWageForm.ls" />
				</a-form-model-item>
				<!-- 				<a-form-model-item label="提成" prop="tc">
					<a-input prefix="￥" v-model="addWageForm.tc" />
				</a-form-model-item> -->
			</a-form-model>
		</a-modal>

		<!-- 修改工资弹窗 -->
		<a-modal v-model="editWageModal" title="修改工资" @ok="editWageSubmit" @cancel="editWageModal = false" ok-text="修改"
		 cancel-text="取消">
			<a-form-model ref="editWageForm" :model="editWageForm" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="流水" prop="ls">
					<a-input prefix="￥" style="width: 90%" v-model="editWageForm.ls" />
				</a-form-model-item>
				<a-form-model-item label="系数">
					{{editWageForm.xs}}
				</a-form-model-item>
				<a-form-model-item label="实发工资">
					<span style="color: #73d13d;">￥ {{editWageForm.sfgz}}</span>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	export default {
		data() {
			return {
				moment,
				locale,
				id: '',
				wageId: '',
				detail: '',
				loading: false,
				imageUrl: '',
				wxList: [],
				wageList: [],
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 14
				},
				basicForm: {},
				addWageModal: false,
				addWageForm: {},
				editWageModal: false,
				editWageForm: {},
				basicFormRules: {
					name: [{
						required: true,
						message: '请填写姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请填写电话',
						trigger: 'blur',
					}],
					idcard: [{
						required: true,
						message: '请填写身份证号',
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change',
					}],
				},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
			this.getWxList()
		},
		methods: {
			tabChange(value) {
				if (value == 2) {
					this.getWageList()
				}
			},

			photoChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.basicForm.photo = info.file.response.data;
					this.loading = false;
				}
			},

			basicSubmit() {
				this.$refs.basicForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$http.post('/admin/index.php/admin/Talents/anchorSave', {
							id: this.id,
							name: this.basicForm.name,
							phone: this.basicForm.phone,
							sex: this.basicForm.sex,
							idcard: this.basicForm.idcard,
							stature: this.basicForm.stature,
							weight: this.basicForm.weight,
							speciality: this.basicForm.speciality,
							cont: this.basicForm.cont,
							photo: this.basicForm.photo,
							wx: this.basicForm.wx,
							isValid: this.basicForm.isValid,
						}).then(res => {
							this.loading = false
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},

			getDetail() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/Talents/anchorInfo', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.basicForm = res.data.data
					}
				})
			},

			getListData(value) {
				let listData;
				for (let i in this.wageList) {
					if (moment(value).locale('zh-cn').format('YYYY-MM-DD') == this.wageList[i].date) {
						listData = this.wageList[i]
					}
				}
				return listData || '';
			},

			getWageList() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/Talents/wagesList', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.wageList = res.data.data
					}
				})
			},

			editWage(id) {
				this.editWageModal = true
				this.wageId = id
				this.$http.post('/admin/index.php/admin/Talents/wagesInfo', {
					id: id
				}).then(res => {
					if (res.data.code == 1) {
						this.editWageForm = res.data.data
					}
				})
			},

			addWageSubmit() {
				this.$http.post('/admin/index.php/admin/Talents/wagesSave', {
					anchor: this.id,
					date: moment(this.addWageForm.date).locale('zh-cn').format('YYYY-MM-DD'),
					ls: this.addWageForm.ls,
				}).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg)
						this.addWageModal = false
						this.getWageList()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},

			editWageSubmit() {
				this.$http.post('/admin/index.php/admin/Talents/wagesSave', {
					id: this.wageId,
					anchor: this.id,
					ls: this.editWageForm.ls,
				}).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg)
						this.editWageModal = false
						this.getWageList()
					}
				})
			},

			getWxList() {
				this.$http.get('/admin/index.php/admin/User/userFind').then(res => {
					if (res.data.code == 1) {
						this.wxList = res.data.data
					}
				})
			},
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	.avatar-uploader {
		display: flex;
		justify-content: center;
	}

	.avatar-uploader>.ant-upload {
		width: 150px;
		height: 200px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}
</style>
